orders-planner-line-ui-cells(onMouseEnter="{onOver}" onMouseLeave="{onOut}" onClick="{onClick}")
  .cell
  script(type="typescript").
    this.mixin('orders.planner.line-ui.cells');
